import React from 'react'
import {useGlobalData} from "../../context/globalDataProvider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import {confirmation, primaryRed, validation} from "../../styles/variables";

const useStyles = makeStyles({
  status: {
    color: validation,
    fontSize: '0.75rem',
    overflow:"hidden"
  },
  ERROR: {
    color: primaryRed
  },
  WORKING: {
    color: confirmation
  }
})

export function IntegrationInfoField({drawerOpen}) {
  const {metrics} = useGlobalData()
  const classes = useStyles()
  const {t} = useTranslation()
  return (
    <div className={clsx(classes.status, classes[metrics?.integrationStatus])} title={t('integrationStatus.pascom.label')+': '+ t(`integrationStatus.pascom.${metrics?.integrationStatus}`)}>
      <span>&#9673;</span> {drawerOpen &&
      <span>{t('integrationStatus.pascom.label')}: {t(`integrationStatus.pascom.${metrics?.integrationStatus}`)}</span>}
    </div>
  )
}


